import styled from 'styled-components'

export const SuggestionText = styled.span`
  display: inline;
  cursor: pointer;
  text-decoration: underline;
  color: blue;
`
